export var openingTimeTypes = {
  OPEN: "OP",
  CLOSED: "CL"
};
export var openingTimeWeekdays = {
  SUNDAY: 1,
  MONDAY: 2,
  TUESDAY: 3,
  WEDNESDAY: 4,
  THURSDAY: 5,
  FRIDAY: 6,
  SATURDAY: 7
};
export var bookingRuleTypes = {
  MIN_LEAD_TIME: "AH",
  MAX_LEAD_TIME: "MA",
  MIN_BOOKING_PERIOD: "MD",
  MAX_BOOKING_PERIOD: "MM"
};